export enum LottiePosition {
  Centered = 'centered',
  // outside
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
  // inside
  InsideTop = 'inside-top',
  InsideBottom = 'inside-bottom',
  InsideLeft = 'inside-left',
  InsideRight = 'inside-right',
  InsideTopLeft = 'inside-top-left',
  InsideTopRight = 'inside-top-right',
  InsideBottomLeft = 'inside-bottom-left',
  InsideBottomRight = 'inside-bottom-right',
}
